import { render, staticRenderFns } from "./LoginAd.vue?vue&type=template&id=60960737&scoped=true"
import script from "./LoginAd.vue?vue&type=script&lang=js"
export * from "./LoginAd.vue?vue&type=script&lang=js"
import style0 from "./LoginAd.vue?vue&type=style&index=0&id=60960737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60960737",
  null
  
)

export default component.exports